import React from 'react'
import { Field } from 'redux-form'

import { email, required } from 'redux-form-validators/lib/'

import { TextField } from '@foodsby/nutrient'
import { Submitting } from '../common/Submitting'

const UnsubscribeForm = ({ handleSubmit, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name={`EmailAddress`}
        component={TextField}
        type="text"
        validate={[
          required({ msg: `Email is required` }),
          email({ msg: `Valid Email is required` })
        ]}
        placeholder="example@email.com"
      />

      {submitting ? (
        <Submitting />
      ) : (
        <button className="primary panel-submit" type="submit">
          {'Yes'}
        </button>
      )}
    </form>
  )
}

export default UnsubscribeForm
